import React from 'react'
import ReactHtmlParser from 'react-html-parser'

class MajorCase extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      majorCase: {},
      isLoading: false,
      error: null,
    }
  }

  componentDidMount() {
    this.setState({isLoading: true})
    const slug = this.props.match.params.url;
    fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/wp/v2/cas_clients?slug=${slug}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      }
    })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error("Une erreur s'est produite.")
        }
      })
      .then(articles => this.setState({majorCase: articles[0], isLoading: false}))
      .catch(error => this.setState({error, isLoading: false}));
  }

  render() {
    const majorCase = this.state.majorCase || {};
    const fields = majorCase.acf || {};
    const title = majorCase.title;
    return (
      <div className="majorcase">
        <div className="video">
          <video controls
            poster={`${process.env.PUBLIC_URL}/images/cases/videos/video-${fields.video}.jpg`}
            src={`${process.env.PUBLIC_URL}/images/cases/videos/video-${fields.video}.mp4`} >
            Vidéo {title}
          </video>
        </div>
        <div className="container">
          <div className="row no-gutters">
            <div className="col-12">
              <img alt={title} className="logo" src={fields.logo} />
              <p><b>Le challenge</b></p>
              { ReactHtmlParser(fields.challenge) }
            </div>
            <div className="col-12 col-md-6">
              <img alt="" src={fields.image1} />
            </div>
            <div className="col-12 col-md-6">
              <div className="majorcase__content--right">
                <b>La réponse</b><br/>
                { ReactHtmlParser(fields.reponse) }
              </div>
            </div>
            <div className="col-12 col-md-6 order-last">
              <div className="majorcase__content--left">
                { fields.recompenses &&
                  <div>
                    <p><b>Récompenses</b></p>
                    { ReactHtmlParser(fields.recompenses) }
                    <br/>
                  </div>
                }
                <div className="popin__tags">
                  <p><b>{fields.client}</b></p>
                  <p>{majorCase.tags}</p>
                </div>

              </div>
            </div>
            <div className="col-12 col-md-6 order-md-last">
              <img alt="" src={fields.image2} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MajorCase




// WEBPACK FOOTER //
// ./src/containers/MajorCase.jsx